module.exports = __webpack_public_path__ + "static/img/page2.c2ca54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/page2.png
// module id = tY6C
// module chunks = 2